module.exports = __webpack_public_path__ + "img/tretonian-grey.d8ce73c.svg";